(function(){
  /* Lumeanis rollback: drawer forcing disabled. Native Halo cart behavior restored. */
  window.lumeanisDrawerOnlyFinal = false;
})();
